import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxiserviceinlohegaon() {



const cardData = {
  keyword: "Taxi Service in Lohegaon",
  heading: "Lotus Cab: Taxi Service in Lohegaon",

  headingDescription:
    "Lotus Cab offers reliable, professional, and affordable Taxi Service in Lohegaon for daily commuting, airport transfers, corporate travel, family trips, and outstation journeys. Lohegaon is a fast-growing residential and airport-connected area in Pune, making punctual and comfortable transportation extremely important. Whether you need a timely airport pickup, AC sedan for business meetings, SUV for family travel, luxury car for special occasions, or mini bus for group trips, we provide a complete fleet solution under one platform. Our vehicles are fully air-conditioned, GPS-enabled, regularly sanitized, and maintained for smooth city and highway performance. We follow transparent per-kilometer pricing with no hidden charges and flexible one-way, round-trip, and same-day travel packages. Professional, background-verified chauffeurs ensure safe driving and courteous service. With 24/7 customer support and instant online booking options, Lotus Cab guarantees stress-free, comfortable, and punctual taxi service in Lohegaon for every travel need.",

  top: "Top Places to Visit in Pune from Lohegaon with Lotus Cab",

  topPlaces: [
    {
      title: "Pune Airport",
      description:
        "Lohegaon is located near Pune International Airport, making airport travel one of the most common transportation needs. Our taxi service ensures timely airport pickup and drop with flight tracking support for delays or early arrivals. AC sedans provide comfortable travel with luggage space. Professional drivers assist with baggage handling and ensure punctual arrival. Corporate travelers rely on our disciplined service for business flights. Families prefer spacious SUV options for comfortable airport transfers. Same-day airport return trips are also available. Lotus Cab guarantees safe and smooth airport connectivity from Lohegaon."
    },
    {
      title: "Aga Khan Palace",
      description:
        "Aga Khan Palace is a peaceful historical monument near Lohegaon that reflects India’s freedom movement history. It is surrounded by beautiful gardens ideal for family visits. Booking a cab from Lohegaon ensures quick and smooth access to this landmark. AC vehicles maintain comfort even during warm afternoons. Our drivers are familiar with city routes to avoid traffic congestion. Flexible waiting options allow relaxed sightseeing. Ideal for short city heritage tours. Lotus Cab ensures safe and convenient travel."
    },
    {
      title: "Shaniwar Wada",
      description:
        "Shaniwar Wada is a historic fort representing Pune’s rich Maratha heritage. Located in central Pune, it attracts tourists throughout the year. Taxi service from Lohegaon ensures reliable city connectivity. AC sedans provide comfortable travel during peak hours. SUV options are suitable for families and group visits. Drivers manage traffic routes efficiently for timely arrival. Flexible return scheduling makes sightseeing convenient. Ideal for cultural and historical exploration."
    },
    {
      title: "Khadakwasla Dam",
      description:
        "Khadakwasla Dam is a peaceful picnic destination near Pune, ideal for family outings and weekend relaxation. Outstation cabs from Lohegaon provide smooth highway travel. Comfortable seating ensures enjoyable round-trip journeys."
    },
    {
      title: "Sinhagad Fort",
      description:
        "Sinhagad Fort is a popular weekend getaway requiring careful hill-road driving. SUV cabs from Lohegaon are ideal for safe ghat travel. Experienced drivers ensure stable and disciplined driving."
    },
    {
      title: "Lonavala",
      description:
        "Lonavala is a scenic expressway destination perfect for weekend trips. AC sedans and SUVs provide comfortable long-distance travel from Lohegaon."
    },
    {
      title: "Magarpatta City",
      description:
        "Corporate clients often travel from Lohegaon to Magarpatta City for office work. Our professional cab service ensures punctual corporate transfers."
    },
    {
      title: "Phoenix Marketcity",
      description:
        "A popular shopping and entertainment destination near Lohegaon. Taxi service ensures easy drop and pickup for families and tourists."
    }
  ],

  services: [
    {
      name: "Lohegaon Taxi Service",
      description:
        "Our Lohegaon taxi service provides dependable transportation for daily travel, airport transfers, corporate rides, and outstation trips. Customers can choose from AC sedans, SUVs, luxury cars, and mini buses based on their travel requirements. Vehicles are regularly serviced and sanitized to ensure hygiene and safety. Professional chauffeurs ensure punctual pickup and disciplined driving. Transparent fare structure eliminates hidden costs. Ideal for individuals, families, and corporate clients. Flexible one-way and round-trip packages available. Lotus Cab guarantees smooth and comfortable travel in Lohegaon."
    },
    {
      name: "AC Cab Lohegaon",
      description:
        "Fully air-conditioned cabs are available for comfortable travel during all seasons. AC sedans are perfect for daily office commuting and airport transfers. Spacious interiors ensure relaxed seating. Vehicles are clean and well-maintained. Drivers ensure punctual service and safe driving. Ideal for city and short-distance travel."
    },
    {
      name: "SUV Cab Lohegaon",
      description:
        "Spacious SUV taxis are ideal for family travel, group outings, and extra luggage requirements. Comfortable seating and stable highway performance ensure relaxed journeys."
    },
    {
      name: "Luxury Cab Lohegaon",
      description:
        "Premium luxury vehicles are available for executive meetings, VIP travel, and special occasions. Elegant interiors and professional chauffeurs enhance travel experience."
    },
    {
      name: "Airport Pickup Lohegaon",
      description:
        "Reliable airport pickup service with flight tracking and punctual arrival guarantee. Professional drivers assist with luggage handling."
    },
    {
      name: "Outstation Cab Lohegaon",
      description:
        "Comfortable long-distance taxi service from Lohegaon to Mumbai, Nashik, Mahabaleshwar, and other destinations."
    },
    {
      name: "Corporate Cab Lohegaon",
      description:
        "Dedicated corporate transportation solutions for office staff, business meetings, and IT professionals."
    },
    {
      name: "Online Cab Booking Lohegaon",
      description:
        "Instant online booking with transparent pricing, quick confirmation, and 24/7 customer support."
    }
  ],

  tableData: [
    ["Lohegaon Taxi Service", "AC Cab Lohegaon"],
    ["Sedan Cab Lohegaon", "SUV Cab Lohegaon"],
    ["Luxury Cab Lohegaon", "Corporate Cab Lohegaon"],
    ["Family Trip Cab Lohegaon", "Airport Pickup Lohegaon"],
    ["Airport Drop Lohegaon", "Online Cab Booking Lohegaon"],
    ["One Way Cab Lohegaon", "Round Trip Cab Lohegaon"],
    ["Mini Bus Lohegaon", "Chauffeur Driven Cab Lohegaon"],
    ["Budget Cab Lohegaon", "Same Day Cab Lohegaon"],
    ["Outstation Cab Lohegaon", "Per Km Rate Cab Lohegaon"],
    ["Weekend Trip Cab Lohegaon", "Best Cab Service Lohegaon"]
  ],

  whychoose: [
    { WhyChooseheading: "Punctual Airport Transfers", WhyChoosedescription: "Timely airport pickup and drop service with flight tracking support." },
    { WhyChooseheading: "Transparent Pricing", WhyChoosedescription: "Clear per-kilometer fare breakdown with no hidden charges." },
    { WhyChooseheading: "Professional Drivers", WhyChoosedescription: "Background-verified chauffeurs trained for city and highway travel." },
    { WhyChooseheading: "Wide Fleet Options", WhyChoosedescription: "Sedans, SUVs, luxury cars, and mini buses available." },
    { WhyChooseheading: "Clean & Sanitized Vehicles", WhyChoosedescription: "Regular vehicle maintenance and hygiene checks." },
    { WhyChooseheading: "Corporate Travel Support", WhyChoosedescription: "Reliable transportation for IT parks and offices." },
    { WhyChooseheading: "Flexible Packages", WhyChoosedescription: "One-way, round-trip, and hourly rental options." },
    { WhyChooseheading: "24/7 Customer Assistance", WhyChoosedescription: "Round-the-clock booking and support service." }
  ]
};

const faqData = [
  { question: "Do you provide airport pickup in Lohegaon?", answer: "Yes, we provide reliable airport pickup and drop service with flight tracking support." },
  { question: "Are AC vehicles available?", answer: "Yes, all our vehicles are fully air-conditioned for comfortable travel." },
  { question: "Is online booking available?", answer: "Yes, customers can book instantly online with transparent pricing." },
  { question: "Do you offer outstation travel?", answer: "Yes, we provide long-distance taxi services from Lohegaon." },
  { question: "Are drivers verified?", answer: "Yes, all chauffeurs are background-verified and professionally trained." },
  { question: "Is per km pricing transparent?", answer: "Yes, complete fare breakdown is shared before confirmation." },
  { question: "Are SUVs available?", answer: "Yes, spacious SUVs are available for family and group travel." },
  { question: "Is mini bus service available?", answer: "Yes, mini bus options are available for group bookings." },
  { question: "Is 24/7 support available?", answer: "Yes, our support team is available round-the-clock." },
  { question: "Do you provide corporate taxi service?", answer: "Yes, we offer dedicated corporate cab solutions in Lohegaon." }
];

const testimonials = [
  { id: 1, name: "Mr. Aditya Sharma", feedback: "Excellent airport taxi service from Lohegaon. Very punctual and clean vehicle. Highly recommended.", rating: 5 },
  { id: 2, name: "Ms. Kavita Joshi", feedback: "Booked SUV for family trip. Comfortable ride and professional driver.", rating: 5 },
  { id: 3, name: "Corporate Client", feedback: "Reliable corporate cab service with proper billing support and punctuality.", rating: 5 },
  { id: 4, name: "Mr. Sameer Patil", feedback: "Used outstation cab from Lohegaon. Smooth highway driving and fair pricing.", rating: 5 },
  { id: 5, name: "Mrs. Neha Kulkarni", feedback: "Very convenient online booking and quick confirmation. Great experience overall.", rating: 5 }
];




































































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi Service in Lohegaon",
  "image": "https://lotuscab.com/assets/images/lohegaon-cab.jpg",
  "description": "Book reliable Taxi Service in Lohegaon with Lotus Cab. Choose from AC, sedan, SUV, luxury cabs, Mini Bus, or chauffeur-driven rides for one-way, round trips, family trips, corporate travel, airport transfers, weekend trips, and outstation trips. Affordable per km rates and same-day options available.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "610"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "150",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/lohegaon-taxi-service"
  }
};





  return (
    <div>
      



<Helmet>
  <title>Taxi Service in Lohegaon | Lotus Cab | Call +91 8767592195</title>
  <meta 
    name="description" 
    content="Book reliable Taxi Service in Lohegaon with Lotus Cab. AC, sedan, SUV, luxury cabs, Mini Bus & chauffeur-driven rides for one-way, round trips, family trips, corporate travel, airport transfers, weekend & outstation trips. Affordable per km rates. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Lohegaon Taxi Service, AC Cab Lohegaon, Sedan Cab Lohegaon, SUV Cab Lohegaon, Luxury Cab Lohegaon, Corporate Cab Lohegaon, Family Trip Cab Lohegaon, Airport Pickup Lohegaon, Airport Drop Lohegaon, Online Cab Booking Lohegaon, One Way Cab Lohegaon, Round Trip Cab Lohegaon, Mini Bus Lohegaon, Chauffeur Driven Cab Lohegaon, Budget Cab Lohegaon, Same Day Cab Lohegaon, Outstation Cab Lohegaon, Per Km Rate Cab Lohegaon, Weekend Trip Cab Lohegaon, Best Cab Service Lohegaon" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/72.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Taxiserviceinlohegaon;